// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__31tCu","error":"InputSecondary_error__2FYpa","disabled":"InputSecondary_disabled__V2OTO"};